import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Flex, Box } from "sprout-ui-primitives";
import { themeGet } from "sprout-ui-theme";
import styled, { keyframes } from "styled-components";
import { ItemType, UserType } from "sprout-graphql";
const shimmer = keyframes`
  0% {
    opacity: 0.25;
  }

  100% {
    opacity: 1;
  }
`;
const ShimmerBox = styled(Box)`
  animation-name: ${shimmer};
  animation-duration: 1s;
  opacity: 0.25;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  animation-timing-function: steps(10, end);
  background: ${themeGet("colors.grey.200")};
`;
const SearchItemPlaceholder = (props)=>{
    const { type  } = props;
    return /*#__PURE__*/ _jsxs(Flex, {
        p: "8px 16px",
        children: [
            /*#__PURE__*/ _jsx(ShimmerBox, {
                width: "36px",
                height: "36px",
                flex: "none",
                mr: "16px",
                borderRadius: type === UserType.User ? "50%" : type === ItemType.Post ? "12px" : "3px"
            }),
            /*#__PURE__*/ _jsx(Flex, {
                flex: "auto",
                minWidth: "0",
                flexDirection: "column",
                justifyContent: "center",
                children: type === UserType.User ? /*#__PURE__*/ _jsx(ShimmerBox, {
                    maxWidth: "240px",
                    height: "17px"
                }) : /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        /*#__PURE__*/ _jsx(ShimmerBox, {
                            maxWidth: "360px",
                            height: "13px",
                            mb: "2px"
                        }),
                        /*#__PURE__*/ _jsx(ShimmerBox, {
                            maxWidth: "640px",
                            height: "17px"
                        })
                    ]
                })
            })
        ]
    });
};
export default SearchItemPlaceholder;
